import React, { useEffect, useState, useContext } from 'react';
import { FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import { commonFilter, NoneArrow } from '../constants/StyleConstants';
import { InventoriesContext } from '../contexts/InventoriesContext';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
  formControl: props => ({
    minWidth: 120,
    width: props.variableWidth ? props.variableWidth : 300,
  }),
  selectWrapper: {
    marginTop: 8,
    marginBottom: 4,
  },
}));

const CountrySelect = ({ value, setValue, title = 'País', matchById, readOnly, variableWidth }) => {
  const [options, setOptions] = useState([]);
  const classes = useStyles({ variableWidth: variableWidth === true ? 'fit-content' : variableWidth });
  const { getTheCountries } = useContext(InventoriesContext);

  useEffect(() => {
    getTheCountries().then(res => setOptions(res));
  }, []);

  return (
    <div className={classes.selectWrapper}>
      <FormControl className={classes.formControl}>
        <InputLabel id="select-country-label">{title}</InputLabel>
        <Select
          IconComponent={readOnly ? NoneArrow : undefined}
          margin="dense"
          labelId="select-country-label"
          id="country-select"
          inputProps={{ readOnly: readOnly }}
          value={value}
          onChange={e => setValue(e.target.value)}>
          {options &&
            options.map((country, index) => (
              <MenuItem key={index} value={matchById ? country.id : country}>
                {country.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default CountrySelect;
